import type {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {SessionService } from '~core/services/session.service';
import { AUTH_URLS } from '~core/constants/urls.constants';
import { AlertService } from '~core/services/ui/alert.service';
import {COMPANY_AUTH} from "~core/constants/context-token.constants";


export function authenticationInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const sessionService = inject(SessionService);
    const alertService = inject(AlertService);
    const router = inject(Router);

    const clonedRequest = attachToken(request, sessionService);
    return handleRequest({
        request: clonedRequest,
        next,
        sessionService,
        alertService,
        router,
    });
}

function attachToken(
    request: HttpRequest<unknown>,
    sessionService: SessionService | null,
): HttpRequest<unknown> {

    let Token = sessionService?.getUserToken() ;
    if (request.context.get(COMPANY_AUTH)) {
        Token = sessionService?.getCompanyToken() ;
    }
    //console.log("Interceptor Token:",Token);
    if (Token) {
        return request.clone({
            setHeaders: { Authorization: `Bearer ${Token}` },
        });
    }
    return request;
}

function handleRequest(parameters: {
    request: HttpRequest<unknown>;
    next: HttpHandlerFn;
    sessionService: SessionService;
    alertService: AlertService;
    router: Router;
}): Observable<HttpEvent<unknown>> {
    return parameters.next(parameters.request).pipe(
        catchError((errorResponse: HttpErrorResponse) =>
            handleErrors({
                errorResponse,
                ...parameters,
            }),
        ),
    );
}

function handleErrors(parameters: {
    request: HttpRequest<unknown>;
    next: HttpHandlerFn;
    sessionService: SessionService;
    alertService: AlertService;
    router: Router;
    errorResponse: HttpErrorResponse;
}): Observable<HttpEvent<unknown>> {
    if (isTokenError(parameters.errorResponse)) {
        parameters.sessionService.logout();
        void parameters.router.navigate([AUTH_URLS.logIn]);
        return throwError(() => new Error('Session expired. Please log in again.'));
    }


    return throwError(() => parameters.errorResponse);
}

function isTokenError(errorResponse: HttpErrorResponse): boolean {
    return (
        errorResponse.status === 401 /*&&
        [AppError.ACCESS_TOKEN_NOT_FOUND, AppError.ACCESS_TOKEN_EXPIRED].includes(
            errorResponse.error.internalCode,
        )*/
    );
}

